export default __webpack_public_path__ + "static/MediaContentThree-7aa1fc57c8a21434548c7a28aac4deae.webp";